export enum SettingsRulesDataEventObjectsEnum {
  // Rule library.
  TEMPLATE_CATEGORY = 'template_category',
  TEMPLATE_SEARCH = 'template_search',
  TEMPLATE_CATEGORY_INFO = 'template_category_info',
  TEMPLATE_LIBRARY_LEARN_MORE = 'template_library_learn_more',
  CREATE_FROM_TEMPLATE = 'create_from_template',
  CREATE_FROM_CUSTOM = 'create_from_custom',
  FRODO_INPUT_MESSAGE = 'frodo_input_message',

  // Rule editor.
  MORE_OPTIONS = 'more_options',
  CREATE_RULE_BUNDLE = 'create_rule_bundle',
  UPDATE_RULE_BUNDLE = 'update_rule_bundle',
  DELETE_RULE_BUNDLE = 'delete_rule_bundle',

  // Other.
  GLG_INDIVIDUAL_RULE_WARNING = 'glg_individual_rule_warning',

  // Rule tester
  RULE_TESTER = 'rule_tester',
  RULE_TESTER_SEARCH_BAR = 'rule_tester_search_bar',
  RULE_TESTER_RECENT_CONV = 'rule_tester_recent_conversation',
  RULE_TESTER_TEST = 'rule_tester_test',
  RULE_TESTER_TEST_RESULT = 'rule_tester_test_result',
  RULE_TESTER_ANOTHER_CONV = 'rule_tester_pick_other_conv',
  RULE_TESTER_TEST_AGAIN = 'rule_tester_test_again',
  RULE_TESTER_CONDITION_RESULT = 'rule_tester_condition_result',
  RULE_TESTER_AI_PROMPT_RESULT = 'rule_tester_ai_prompt_result',
  RULE_TESTER_AI_REPLY_ECHOES_DETECTED_RESULT = 'rule_tester_ai_reply_echoes_detected_result',
  RULE_TESTER_ACTION_RESULT = 'rule_tester_action_result',

  // Prompt validation.
  RULE_PROMPT_VALIDATION_REWRITE_QUESTION = 'rule_prompt_validation_rewrite_question',
  RULE_PROMPT_VALIDATION_EXAMPLES = 'rule_prompt_validation_examples',
}
